import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ClipboardList } from 'lucide-react';
import { useLocale, useT } from '../contexts/LocaleProvider';
import { LT } from '../contexts/AppCatalogueContext';
import api from '../utils/api';

/* One slim line on the hub while a survey is open and you haven't
 * answered it · gone as soon as you have. Silent on any error: a missing
 * nudge is fine, a broken home page isn't. */
export default function SurveyNudge({ survey }) {
  const { locale } = useLocale();
  const t = useT();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let alive = true;
    api.surveyMe(survey.slug)
      .then(s => { if (alive) setShow(s.open && !s.response); })
      .catch(() => {});
    return () => { alive = false; };
  }, [survey.slug]);

  if (!show) return null;
  const tr = (o) => o[locale] || o.fr;
  return (
    <Link to={`/surveys/${survey.slug}`}
          className="mb-5 flex items-center gap-3 px-4 py-3 transition hover:opacity-80"
          style={{ background: LT.yellowLight, borderTop: `1px solid ${LT.yellow}`, borderBottom: `1px solid ${LT.yellow}`, color: LT.greenDeep }}>
      <ClipboardList className="h-4 w-4 shrink-0" />
      <span className="min-w-0 flex-1 text-[14px] leading-snug">
        <b className="font-medium">{tr(survey.intro.title)}</b>
        <span className="hidden sm:inline" style={{ color: '#4d6157' }}> · {tr(survey.intro.eyebrow)}</span>
      </span>
      <span className="shrink-0 inline-flex items-center gap-1 text-[13px] font-medium">
        {t('splash.survey.cta')} <ArrowRight className="h-3.5 w-3.5" />
      </span>
    </Link>
  );
}
